export default {
  data () {
    return {
      serveIndex: 1,
      companyIndex: 1,
      companyList: [
        // {
        //   type: 1,
        //   name: '平安集团',
        //   before: '想通过微信运营客户，却卡在注册微信容易封号这个难题上。在网上四处搜索，众说纷纭，所谓的教程经验很多但都太基础，看了之后，根本解决不了问题。',
        //   after: '多方了解，最终选择了奥创商学院。通过学习及老师系统化的落地指导，仅用了1个月时间，就成功注册了数千微信号。有什么问题还能随时咨询导师，为公司节省了大量的时间，抢占先机。'
        // },
        {
          type: 2,
          name: '正保集团',
          before: '微信运营过程中，经常出现工作号被判定为营销号导致封号，有时候还会遇到同行恶意投诉导致封号，长此以往，挺困扰。',
          after: '通过梳理微信最新的安全策略和封号逻辑，进行科学的养号，因误诊判定营销号或被恶意投诉等情况封号概率降低了80%以上。'
        },
        {
          type: 3,
          name: '新东方集团',
          before: '流量部门获客成本高昂，很多时候有流量进来咨询，但客户转化率较低。',
          after: '通过系统化的培训，掌握了微信客户在线成交的重要法门，结合奥创的工作手机管理系统，广告成本大幅降低的同时，多维度提高了与学员的沟通效率和接待质量，一个月时间，学员转化率提升了50%。'
        },
        {
          type: 4,
          name: '某金融集团',
          before: '销售经常给客户乱说，违规承诺给客户返点，夸大宣传产品范围等，7月引发一次客户集体投诉维权，公司直接经济损失近1个亿。',
          after: '老师指导从客户来源、资源分配到销售沟通内容等方面进行全方位系统化风控方案，用方法跟工具相结合的方式，为客户解决企业运营风控难题。'
        }
      ]
    }
  },
  methods: {
    moveLeft () {
      if (this.companyIndex > 1) {
        this.companyIndex--
      }
    },
    moveRight () {
      if (this.companyIndex < 3) {
        this.companyIndex++
      }
    }
  }
}
